import { Component, Input } from '@angular/core';
@Component({
  standalone: false,
  selector: 'app-project-deliverable-carryover-label',
  templateUrl: './project-deliverable-carryover-label.component.html',
  styleUrls: ['./project-deliverable-carryover-label.component.scss'],
})
export class ProjectDeliverableCarryoverLabelComponent {
  @Input() isShortForm: boolean = false;
}
